import './instrument-client';

// Polyfills (These are for 3rd party libraries that lack them)
// Normally preset-env would pick them up and polyfill automatically
// but when they're in a node_modules folder it needs to be explicitly
// added to babel-loader config, however we haven't tracked down all
// deps that need these things (yet)
import 'core-js/features/object/assign';
import 'core-js/features/object/keys';
import 'core-js/features/object/values';

import 'core-js/features/map';
import 'core-js/features/set';
import 'core-js/features/array';
import 'core-js/es/number';

// Internationalization support
import i18n from './app/i18n';

if (!window.location.hostname.startsWith('dev.')) {
  if (window.location.protocol === 'file:') {
    alert(
      `It appears that you have saved this page to your computer or mobile device, for security reasons you will not be able to submit any information and functionality may be extremely limited. Please visit us online at ${getWebHost()} for the full experience.`,
    );
  }
}

import { hydrateRoot } from 'react-dom/client';
import { Router, browserHistory, match } from 'react-router';

import altResolver from './shared/alt-resolver';
import { alt } from './app/utils/alt';
import routes from './app/routes';
import Realtime from './app/realtime';

import AppActions from './app/actions/app';
import { getWebHost } from './app/utils/MultiDomain';

// Force the loading of the stores/actions chunk in webpack (otherwise we have nowhere to bootstrap)
import './app/stores/index';

import 'font-awesome/css/font-awesome.min.css';
import './app/styles/main.scss';
import { I18nextProvider } from 'react-i18next';
import { hydrate } from '@/utils/Iso';

global.loadedFromServer = true;
global.process = { env: import.meta.env };

// Avoid scrolling if we have a hash present, indicating we should scroll to a spot
const handleUpdate = () => {
  const { hash, pathname } = window.location;
  // Don't scroll on changing opportunity browsing params, don't scroll or trigger closing of modals on forms (avoids closing the draft choice modal on invalid draft id)
  if (
    pathname.startsWith('/opportunities/browse') ||
    pathname.startsWith('/forms/') ||
    pathname.includes('/manage/forms/submissions') ||
    pathname.includes('/manage/employees/list')
  ) {
    return;
  }

  if (!hash || hash.trim().length === 0) {
    window.scrollTo(0, 0);
  }
  // Close modals just incase we navigated from links within them
  AppActions.setModal(false);
};

const buildRoutes = (initialState) => ({
  getChildRoutes({ location }, callback) {
    match({ location, routes }, (error, redirectLocation, renderProps) => {
      if (error) {
        console.log(error);
        global.loadedFromServer = false;
        browserHistory.push({ pathname: '/dashboard', query: { error: 'true' } });
        return;
      }
      if (redirectLocation) {
        global.loadedFromServer = false;
        browserHistory.replace(redirectLocation);
        return;
      }

      if (global.loadedFromServer) {
        global.loadedFromServer = false;
        console.log('Initial page render from server (on client), skipping bootstrapping');

        setTimeout(() => callback(null, routes), 0); // Defer to avoid strange double-match issue
        return;
      }

      // Skip bootstrapping for pages where we're replacing the querystring properties to drive filters, and we're just doing a replace on the URL
      if (
        (location.pathname === '/opportunities/browse' ||
          location.pathname.includes('/manage/forms') ||
          location.pathname.includes('/manage/employees/list')) &&
        location.action === 'REPLACE'
      ) {
        setTimeout(() => callback(null, routes), 0); // Defer to avoid strange double-match issue
        return;
      }

      altResolver(
        false, // No req object because client-side
        false, // No res object because client-side
        {
          routes: renderProps.routes,
          params: renderProps.params,
          location: renderProps.location,
          state: initialState,
        },
        (err, nextState) => {
          if (err) {
            console.error('Error resolving async data:', err);
            callback(null, routes);
            return;
          }
          alt.bootstrap(JSON.stringify(nextState));
          callback(null, routes);
        },
      );
    });
  },
});

const state = hydrate(document?.getElementById('alt-state')?.textContent);

// Bootstrap data into client Alt
alt.bootstrap(state);

// Get the mount point
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing root element');

rootElement.innerHTML = '';

const initialRoutes = buildRoutes(state);

hydrateRoot(
  rootElement,
  <I18nextProvider i18n={i18n}>
    <Router onUpdate={handleUpdate} history={browserHistory} routes={initialRoutes} />
  </I18nextProvider>,
);

// Make sure we only initialize the realtime system once
if (typeof global.dsgRealtime === 'undefined') {
  global.dsgRealtime = new Realtime();
}
